import { Container as BaseContainer } from '@hud/web-components/Container/Container';
import { FlowChartHeader } from '@hud/web-components/Hud/FlowChartHeader/FlowChartHeader';
import { Row as RowBase } from '@hud/web-components/Layout/Layout';
import styled from 'styled-components';
import { smRegular } from '@hud/web-components/theme/typography';
import { ModuleLabel } from '@hud/web-components/ThirdParty/ModuleLabel';
import { themeColor } from '@hud/web-components/theme/colors';

export const Row = styled(RowBase)`
  max-height: 400px;
`;

export const FunctionBehaviorChartContainer = styled(BaseContainer)`
  flex: 1;
  overflow: hidden;
`;

export const CenterLoader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const WebviewFlowChartHeader = styled(FlowChartHeader)`
  ${smRegular}
  margin: 0 0 12px 0;
`;

export const TitleModuleLabel = styled(ModuleLabel)`
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    ${smRegular}
    padding: 2px 6px;
    align-items: center;
    background-color: ${themeColor('buttonBackground')};
    border-radius: 6px;
    display: flex;
`;

export const FunctionTitle = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  `;

export const FlowChartContainer = styled.div`
  ${smRegular}
`;
